import { NgsRevealConfig } from './ngs-reveal-config';
import { NgsRevealService } from './ngs-reveal.service';
import { NgModule } from '@angular/core';
import { NgsRevealDirective } from './ngs-reveal.directive';
import { NgsRevealSetDirective } from './ngs-reveal-set.directive';
import { CommonModule } from '@angular/common';
export var NGS_REVEAL_DIRECTIVES = [NgsRevealDirective, NgsRevealSetDirective];
export { NgsRevealConfig } from './ngs-reveal-config';
export var NgsRevealModule = (function () {
    function NgsRevealModule() {
    }
    NgsRevealModule.forRoot = function () {
        return {
            ngModule: NgsRevealModule,
            providers: [NgsRevealConfig, NgsRevealService]
        };
    };
    NgsRevealModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [NGS_REVEAL_DIRECTIVES],
                    declarations: [NGS_REVEAL_DIRECTIVES]
                },] },
    ];
    /** @nocollapse */
    NgsRevealModule.ctorParameters = [];
    return NgsRevealModule;
}());
//# sourceMappingURL=ngs-reveal.module.js.map


//////////////////
// WEBPACK FOOTER
// /Users/mac-jeremy/Projets/fairepart/~/ng-scrollreveal/ngs-reveal.module.js
// module id = ../../../../ng-scrollreveal/ngs-reveal.module.js
// module chunks = 4